import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { Close } from '@mui/icons-material';
import {
  Dialog,
  DialogProps,
  DialogTitle,
  IconButton,
  PaperProps as MuiPaperProps,
} from '@mui/material';

import commonMessages from '@/features/i18n/commonMessages';

interface Props extends Omit<DialogProps, 'onClose' | 'open' | 'title'> {
  children: ReactNode;
  PaperProps?: MuiPaperProps;
  isOpen?: boolean;
  isClosable?: boolean;
  onDialogClose?: () => void;
  title?: ReactNode;
}

const PlootoDialog = ({
  children,
  isClosable = true,
  isOpen = false,
  onDialogClose,
  PaperProps = undefined,
  title,
  ...dialogProps
}: Props) => {
  const { formatMessage } = useIntl();

  return (
    <Dialog {...dialogProps} PaperProps={PaperProps} open={isOpen}>
      {isClosable ? (
        <IconButton
          sx={{ position: 'absolute', top: 0, right: 0, mt: 1.5, mr: 1 }}
          onClick={onDialogClose}
        >
          <Close titleAccess={formatMessage(commonMessages.closeDialog)} />
        </IconButton>
      ) : null}
      {title ? <DialogTitle sx={{ pr: isClosable ? 6 : 3 }}>{title}</DialogTitle> : null}
      {children}
    </Dialog>
  );
};

export default PlootoDialog;
export { Props as DialogProps };
